import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getFunctions, type Functions } from 'firebase/functions';
import { env } from './env';

function getApp(): FirebaseApp {
  const existing = getApps()[0];
  return existing ?? initializeApp(env.firebase);
}

export const firebaseApp: FirebaseApp = getApp();
export const auth: Auth = getAuth(firebaseApp);
export const db: Firestore = getFirestore(firebaseApp);
export const functions: Functions = getFunctions(firebaseApp, 'us-central1');
